import { render } from "./ProjectPagination.vue?vue&type=template&id=54dc6b10"
import script from "./ProjectPagination.vue?vue&type=script&lang=js"
export * from "./ProjectPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__